import type {ReactElement} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {otherKey} from '@Components/ai-chat-window/components/survey/survey.library';
import type {SelectFieldRendererProps} from './fields.types';
import {OptionCard} from './option-card';
import styles from './fields.module.scss';

function renderRadio(isSelected: boolean): ReactElement {
  return <span className={isSelected ? `${styles.radio} ${styles.radioSelected}` : styles.radio} />;
}

export function SelectFieldRenderer({name, step, field}: SelectFieldRendererProps): ReactElement {
  const {control, setValue} = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({field: rhfField}): ReactElement => {
        const current = typeof rhfField.value === 'string' ? rhfField.value : '';
        return (
          <div
            className={styles.optionList}
            role="radiogroup"
            aria-label={step.helpText}
          >
            {field.options.map((opt) => {
              const isSelected = current === opt.value;
              return (
                <OptionCard
                  key={opt.value}
                  label={opt.label}
                  imageUrl={opt.imageUrl}
                  isSharedInTeam={opt.isSharedInTeam}
                  isSelected={isSelected}
                  leadingSlot={renderRadio(isSelected)}
                  onClick={(): void => {
                    setValue(otherKey(name), '');
                    rhfField.onChange(opt.value);
                  }}
                />
              );
            })}
          </div>
        );
      }}
    />
  );
}
